import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'full';
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  className?: string;
  href?: string; // Added href prop for link functionality
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#A020F0]';
  const variantStyles = {
    primary: 'bg-[#A020F0] text-white hover:bg-[#8800cc] focus:ring-[#A020F0]',
    secondary: 'bg-[#FFDE59] text-gray-900 hover:bg-[#FFD700] focus:ring-[#FFDE59]',
    outline: 'bg-transparent border-2 border-[#A020F0] text-[#A020F0] hover:bg-[#A020F0] hover:text-white focus:ring-[#A020F0]'
  };
  const sizeStyles = {
    sm: 'py-1 px-3 text-sm',
    md: 'py-2 px-4 text-base',
    lg: 'py-2.5 px-5 text-lg',
    full: 'py-2.5 px-5 text-lg w-full'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  // If href is provided, render an anchor tag
  if (href) {
    return <a href={href} className={styles} onClick={onClick} {...props} data-id="element-74">
        {children}
      </a>;
  }
  // Otherwise render a button
  return <button className={styles} onClick={onClick} {...props} data-id="element-75">
      {children}
    </button>;
}